import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react'; // Import Swiper and SwiperSlide
import 'swiper/css'; // Import Swiper core styles
import 'swiper/css/navigation'; // Import Swiper navigation styles
import { Autoplay, Navigation } from "swiper/modules";
import { useTranslation,Trans  } from 'react-i18next';
const Logos = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className='lyt-section typ-logo-section' id='institutional'>


                <div className='container'>

                    <div className="heading-wrapper">
                        <div>
                            <h2
                                className="bs-heading typdblue mb-2"
                                data-aos="fade-in"
                                data-aos-delay="200"
                            >
                                {t('institutionalMember')}
                            </h2>
                        </div>
                    </div>

                    <div className='bs-swiper' data-aos="fade-in" data-aos-delay="200">
                        <Swiper
                            modules={[Navigation, Autoplay]} // Pass Navigation module to the modules array
                            spaceBetween={30} // Space between slides
                            slidesPerView={3} // Number of slides to show at once
                            loop={true} // Enable infinite loop
                            navigation={{
                                prevEl: ".previous", // Target for the previous button
                                nextEl: ".next", // Target for the next button
                            }}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1, // 1 slide at a time for small screens
                                },
                                768: {
                                    slidesPerView: 3, // 2 slides at a time for medium screens
                                },
                                1024: {
                                    slidesPerView: 4, // 3 slides at a time for large screens
                                },
                                1100: {
                                    slidesPerView: 6, // 4 slides at a time for large screens
                                },
                            }} // Breakpoints for responsiveness
                            className="swiper-container"
                        >
                            {/* Slide 1 */}
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://naredcowest.com/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/1.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://www.narindia.org/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/2.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://peataindia.org/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/3.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://mchi.net/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/4.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://mahasewa.org/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/5.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://www.credaipune.org/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/6.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <a href='https://mymgp.org/' target='_blank'>
                                            <img
                                                className="img-fluid"
                                                src="/images/home/logos/7.png"
                                                alt="logo"
                                                width={132}
                                                height={116}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <img
                                            className="img-fluid"
                                            src="/images/home/logos/9.png"
                                            alt="logo"
                                            width={132}
                                            height={116}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <img
                                            className="img-fluid"
                                            src="/images/home/logos/10.png"
                                            alt="logo"
                                            width={132}
                                            height={116}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <img
                                            className="img-fluid"
                                            src="/images/home/logos/11.png"
                                            alt="logo"
                                            width={132}
                                            height={116}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box">
                                    <div className="box-icon">
                                        <img
                                            className="img-fluid"
                                            src="/images/home/logos/12.png"
                                            alt="logo"
                                            width={132}
                                            height={116}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>

                        {/* Custom navigation buttons */}
                        <div className="swiper-button-prev previous">
                            <span className="icon icon-right-arrow"></span>
                        </div>
                        <div className="swiper-button-next next">
                            <span className="icon icon-right-arrow"></span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Logos;
